module.exports = __webpack_public_path__ + "static/img/activity_infomation.066e793.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/views/surveys/sapporo/images/activity/activity_infomation.jpg
// module id = MGmh
// module chunks = 0